import request from '@/utils/request'; //引入封装好的 axios 请求
// 需求统计

export function queryXQStatistics() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return request({
    url: '/api/credit/financial/effectByParam',
    method: 'post',
    data: data
  });
} // 融资统计

export function queryRZStatistics() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return request({
    url: '/api/credit/financial/creditByParam',
    method: 'post',
    data: data
  });
} //待推荐企业列表

export function JgList() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return request({
    url: '/api/loan/apply/JgList',
    method: 'post',
    data: data
  });
} //推荐银行列表

export function bankList() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return request({
    url: '/api/v1/user/bankList',
    method: 'post',
    data: data
  });
} //向推荐银行

export function recommend() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return request({
    url: '/api/credit/import/recommend',
    method: 'post',
    data: data
  });
} //查询推荐历史记录

export function jgHistoryList() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return request({
    url: '/api/loan/apply/jgHistoryList',
    method: 'post',
    data: data
  });
} //查询历史记录详情

export function jgHistoryDetail() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return request({
    url: '/api/loan/apply/jgHistoryDetail',
    method: 'post',
    data: data
  });
} //企业推荐情况统计

export function financeEffect() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return request({
    url: '/api/loan/apply/financeEffect',
    method: 'post',
    data: data
  });
} //关注

export function followApply() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return request({
    url: '/api/loan/apply/followApply',
    method: 'post',
    data: data
  });
} //全部关注

export function bathFollow() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return request({
    url: '/api/loan/apply/bathFollow',
    method: 'post',
    data: data
  });
} //查询授信放款信息

export function expertLoanDetailById() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return request({
    url: 'api/loan/apply/expertLoanDetailById',
    method: 'post',
    data: data
  });
} //查询审批列表

export function list() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return request({
    url: '/api/credit/product/list',
    method: 'post',
    data: data
  });
} //审批结果

export function examine() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return request({
    url: '/api/credit/product/examine',
    method: 'post',
    data: data
  });
} //查询审批历史

export function selectHistoryList() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return request({
    url: '/api/credit/product/selectHistoryList',
    method: 'post',
    data: data
  });
} //上报历史记录

export function businessReportHistoryRecord() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return request({
    url: '/api/v1/user/businessReportHistoryRecord',
    method: 'post',
    data: data
  });
} //业务报送监管

export function platformSubmissionRecord() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return request({
    url: '/api/credit/financial/platformSubmissionRecord',
    method: 'post',
    data: data
  });
} //业务报送银行列表

export function bank() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return request({
    url: '/api/v1/user/bankList',
    method: 'post',
    data: data
  });
} //业务报送银行列表

export function reportedByBankingRecord() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return request({
    url: '/api/credit/financial/reportedByBankingRecord',
    method: 'post',
    data: data
  });
} //查看产品详情

export function detail() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return request({
    url: '/api/credit/product/detail',
    method: 'post',
    data: data
  });
} //有贷无贷款

export function loanAndNoLoanAmount() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return request({
    url: '/api/credit/financial/loanAndNoLoanAmount',
    method: 'post',
    data: data
  });
} //获取推荐银行列表

export function BankList() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return request({
    url: '/api/loan/apply/bankList',
    method: 'post',
    data: data
  });
} //用户统计

export function erTotalByParam() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return request({
    url: '/api/credit/financial/userTotalByParam',
    method: 'post',
    data: data
  });
} //获取推荐银行列表

export function frontPageBankList() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return request({
    url: '/api/v1/user/frontPageBankList',
    method: 'post',
    data: data
  });
} //获取推荐银行列表

export function detailByExamineId() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return request({
    url: '/api/credit/product/detailByExamineId',
    method: 'post',
    data: data
  });
}
export function getProductType() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return request({
    url: '/api/credit/dictionary/selectByCode',
    method: 'post',
    params: data
  });
} //查询已申请产品清单

export function applyProList() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return request({
    url: '/api/credit/application/applyProList ',
    method: 'post',
    data: data
  });
}
export function applyBankList() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return request({
    url: '/api/credit/application/applyBankList ',
    method: 'post',
    data: data
  });
}
export function execute() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return request({
    url: '/api/credit/execute/list',
    method: 'post',
    data: data
  });
}
export function selectReportData() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return request({
    url: '/api/v1/report/selectReportData',
    method: 'post',
    data: data
  });
}